import React from 'react';
import '../less/main.less';
import hero_img from '../img/hero_img.png';
import hero_data from '../enums/hero_data.json';
import HowToBlockNew from '../../../../../../auxiliary-components/shared/HowToBlockNew';
import howToBlockItemsData from '../enums/how_to_block_items.json';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import Hero from './../../../../../../auxiliary-components/shared/HeroBlock';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantagesItemsData from '../enums/advantages_items.json';
import Advantages from './../../../../../../auxiliary-components/shared/AdvantagesBlock';
import FilesForDownloadNew from './../../../../../../auxiliary-components/shared/FilesForDownloadNew';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../../../../helpers/canUseDOM';
import QuestionsAdminNew from './../../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import { filterByEnvironment } from '../../../../../../helpers/utils/environmentFilter';

const imagesMap = {
  how_to_block_img_1,
  how_to_block_img_2,
  how_to_block_img_3,
  advantages_img_1,
  advantages_img_2,
  advantages_img_3
}

const howToBlockItems = howToBlockItemsData.map(item => ({
  ...item,
  img: imagesMap[item.img]
}));

const advantagesItems = advantagesItemsData.map(item => ({
  ...item,
  img: imagesMap[item.img]
}));

export default function template() {
  const page = "transfer-by-phone";

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="transfer-by-phone">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <Advantages
          items={advantagesItems}
          title={'TRANSFER_BY_PHONE_NEW_ADVANTAGES_TITLE'}
        />
        <HowToBlockNew
          items={howToBlockItems}
          title={'TRANSFER_BY_PHONE_NEW_HOW_TO_TITLE'}
        />
        {this.state.loader ? (canUseDOM ? <Preloader /> : null) : (
          <>
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'TRANSFER_BY_PHONE_NEW_QUESTIONS_TITLE'}
            />
            <FilesForDownloadNew widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>
          </>
        )}
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('TRANSFER_BY_PHONE_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('TRANSFER_BY_PHONE_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
    </div>
  )
}
